// STUDIO-CAPTURE-INBOX-VISIBILITY-FIX-1 · 오늘 외 예정 방송 선택 (기존 /seller/broadcasts 본인 목록 REUSE).
import React from 'react';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale';
import { CalendarClock } from 'lucide-react';
import api from '@/lib/api';

const CLOSED = new Set(['종료', 'ended', '취소', 'cancelled']);

export const loadUpcoming = async (todayList) => {
  try {
    const today = new Set((todayList || []).map((b) => b.schedule_id));
    const now = Date.now() - 12 * 3600 * 1000;
    return ((await api.get('/seller/broadcasts')).data || [])
      .filter((b) => !b.is_deleted && !CLOSED.has(b.status) && !today.has(b.schedule_id)
        && new Date(b.scheduled_at).getTime() >= now)
      .sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at))
      .slice(0, 8);
  } catch { return []; }
};

export const UpcomingPicker = ({ items, activeId, onPick }) => {
  if (!items?.length) return null;
  return (
    <div className="rounded-xl border border-black/10 dark:border-white/10 px-3 py-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs"
         data-testid="upcoming-broadcasts">
      <span className="inline-flex items-center gap-1 text-[11px] font-black uppercase tracking-widest text-gray-500 shrink-0">
        <CalendarClock size={11} /> 예정 방송
      </span>
      <div className="flex flex-wrap gap-1">
        {items.map((b) => (
          <button key={b.schedule_id} type="button" onClick={() => onPick(b.schedule_id)}
            className={`px-2 py-0.5 rounded-full text-[11px] font-bold border transition-colors ${
              activeId === b.schedule_id ? 'bg-amber-500 text-white border-amber-500'
                : 'border-black/10 dark:border-white/10 text-gray-600 dark:text-gray-300'}`}
            data-testid={`pick-upcoming-${b.schedule_id}`}>
            {format(new Date(b.scheduled_at), 'M/d HH:mm', { locale: ko })} · {b.title}
          </button>
        ))}
      </div>
    </div>
  );
};
